module.exports = __webpack_public_path__ + "img/sld_scb_4_t1_red.ec1bdf9c.svg";